import React, { Component } from "react";
import { Row, Col, Button } from "react-bootstrap";
import { Link } from "react-router-dom";

import CartContext from "./CartContext";

// Adjust these to match the modules exported from your CommonModules file
import {
  RawMaterialsModule,
  ProductionModule,
  InventoryModule,
  PurchasesModule,
  DeliveryManagementModule,
  PackagingManagementModule,
  RetailPosModule,
  ReportsModule,
  AccountingModule,
  CrmModule,
  DemoButton,
  SuppliersModule,
  MarketingModule,
  DigitalCatalogModule,
  LeadsManagementModule,
  QuoteManagementModule,
  SalesOrderModule,
  ECommerceB2CModule,
  ECommerceB2BModule,
  OrdersManagementModule,
  CouponsManagementModule,
} from "./CommonModules";

export class SupplyChain extends Component {
  static contextType = CartContext;

  componentDidMount() {
    window.scrollTo(0, 0);
  }

  getSupplyChainProductType = () => {
    const pt = (this.context && this.context.ProductType) || {};
    return pt.SupplyChain || pt.ERP || pt.ECommerce || null;
  };

  handleTryNow = () => {
    const ctx = this.context || {};
    const { userData, ShowUserLoginNew, prods, SetSelectedProduct } = ctx;

    if (!userData || userData.loginStatus !== "active") {
      if (typeof ShowUserLoginNew === "function") ShowUserLoginNew(true);
      return;
    }

    const targetType = this.getSupplyChainProductType();
    if (targetType && Array.isArray(prods) && prods.length) {
      const selected = prods.find((p) => p.productType === targetType);
      if (selected && typeof SetSelectedProduct === "function") {
        SetSelectedProduct(selected);
        return;
      }
    }

    if (typeof ctx.HandleTryNowButtonClick === "function") {
      ctx.HandleTryNowButtonClick(targetType);
    }
  };

  render() {
    const ctx = this.context || {};
    if (!ctx || !ctx.EcSettings || ctx.EcSettings.length === 0) return <></>;

    const base = ctx.GetEcSettingValueByName
      ? ctx.GetEcSettingValueByName("StorageBlobImageUrl")
      : "";

    const moduleList = [
      RawMaterialsModule,
      SuppliersModule,
      PurchasesModule,
      ProductionModule,
      InventoryModule,
      MarketingModule,
      DigitalCatalogModule,
      LeadsManagementModule,
      QuoteManagementModule,
      CrmModule,
      CouponsManagementModule,
      SalesOrderModule,
      RetailPosModule,
      ECommerceB2CModule,
      ECommerceB2BModule,
      OrdersManagementModule,
      PackagingManagementModule,
      DeliveryManagementModule,

      AccountingModule,
    ];

    return (
      <>
        {/* Hero / Marketing Section */}
        <section
          className="hero container-fluid py-5 bg-white"
          id="supplyChainSection"
        >
          <div className="container">
            <div className="row align-items-center gy-4">
              <div className="col-lg-7">
                <span className="badge-sub">Supply Chain • End-to-end</span>
                <h1 className="display-5 fw-bold mt-3">
                  Supply Chain Management — connect procurement, manufacturing,
                  warehousing and distribution.
                </h1>

                <p className="lead text-muted mb-4">
                  Plan demand, optimize inventory, orchestrate production and
                  deliver on time — all from a single integrated platform.
                </p>

                <p className="mb-3">
                  <strong>Why choose our supply chain solution?</strong>
                </p>

                <div className="row g-3">
                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-dolly" />
                      </div>
                      <div>
                        <h6 className="mb-1">Procurement & Vendors</h6>
                        <small className="text-muted">
                          Vendor onboarding, PO automation and approvals.
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-boxes-stacked" />
                      </div>
                      <div>
                        <h6 className="mb-1">Inventory Optimization</h6>
                        <small className="text-muted">
                          Safety stock, lot control and multi-location
                          visibility.
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-industry" />
                      </div>
                      <div>
                        <h6 className="mb-1">Production Planning</h6>
                        <small className="text-muted">
                          MPS, BOMs, work orders and capacity-aware scheduling.
                        </small>
                      </div>
                    </div>
                  </div>

                  <div className="col-sm-6">
                    <div className="d-flex gap-3 align-items-start">
                      <div className="feature-icon">
                        <i className="fa-solid fa-truck-fast" />
                      </div>
                      <div>
                        <h6 className="mb-1">Distribution & Logistics</h6>
                        <small className="text-muted">
                          Route planning, shipping and carrier integrations.
                        </small>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="mt-4">
                  {/* <Button
                    variant="light"
                    size="lg"
                    className="me-2"
                    onClick={this.handleTryNow}
                  >
                    <i className="fa-solid fa-play me-2" /> Book a demo
                    +91-98805 82728
                  </Button> */}

                  <Button
                    variant="primary"
                    size="lg"
                    as={Link}
                    to="/Checkout"
                    onClick={() =>
                      this.context.HandleTryNowButtonClick(
                        this.context.ProductType.SupplyChain
                      )
                    }
                  >
                    <i className="fa-solid fa-flask me-2" /> Start free trial
                  </Button>
                </div>
              </div>

              <div className="col-lg-5">
                <div className="card card-feature p-4">
                  <div className="card-body">
                    <h5 className="card-title mb-3">
                      Core supply-chain capabilities
                    </h5>
                    <div className="row">
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-warehouse fa-lg me-2" />
                        <strong>Warehouse</strong>
                        <div className="text-muted small">
                          Receiving, putaway, picking & location control.
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-cart-flatbed fa-lg me-2" />
                        <strong>Purchasing</strong>
                        <div className="text-muted small">
                          POs, GRNs and supplier performance.
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-cogs fa-lg me-2" />
                        <strong>Production</strong>
                        <div className="text-muted small">
                          BOMs, routing & shop-floor control.
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-route fa-lg me-2" />
                        <strong>Logistics</strong>
                        <div className="text-muted small">
                          Carrier integrations & shipment tracking.
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-chart-line fa-lg me-2" />
                        <strong>Analytics</strong>
                        <div className="text-muted small">
                          Fill-rate, lead-time and inventory KPIs.
                        </div>
                      </div>
                      <div className="col-6 mb-3">
                        <i className="fa-solid fa-handshake-angle fa-lg me-2" />
                        <strong>Order Fulfillment</strong>
                        <div className="text-muted small">
                          Pick-pack-ship & returns management.
                        </div>
                      </div>
                    </div>

                    <div className="mt-3">
                      {/* <Button
                        variant="primary"
                        size="sm"
                        as={Link}
                        to="#features"
                      >
                        See full feature list
                      </Button> */}
                      {/* <Button
                        variant="outline-secondary"
                        size="sm"
                        as={Link}
                        to="#contact"
                        className="ms-2"
                      >
                        Contact sales
                      </Button> */}
                      <DemoButton></DemoButton>
                    </div>
                  </div>
                </div>
              </div>

              {/* Short description */}
              <div className="col-12 mt-4">
                <div>
                  Our Supply Chain solution gives you demand-driven planning,
                  optimized inventory and an integrated fulfillment flow so you
                  can reduce costs, improve OTIF (on-time in-full) and scale
                  with predictability.
                </div>
              </div>

              {/* Demo / product video */}
              <div className="col-12 mt-4 w-100">
                {/* <video
                  controls
                  height="400px"
                  autoPlay
                  muted
                  loop
                  width="100%"
                  aria-label="Supply Chain demo video"
                >
                  <source
                    src={base + "SupplyChainVideo.mp4"}
                    type="video/mp4"
                  />
                  Your browser does not support the video tag.
                </video> */}
                <img
                  className="w-100"
                  src={base + "carousel4.png"}
                  loading="lazy"
                />
              </div>
            </div>

            {/* What we cover */}
            <div className="row mt-5 modules">
              <div className="col-lg-8">
                <div className="card border-0 shadow-sm">
                  <div className="card-body">
                    <h4 className="mb-3">What we cover</h4>
                    <div className="row g-3">
                      <div className="col-md-6">
                        <ul className="list-unstyled">
                          <li>
                            <strong>Supplier & procurement:</strong> RFQs, POs,
                            approvals & supplier scorecards.
                          </li>
                          <li>
                            <strong>Raw materials:</strong> lot/serial,
                            expiration & traceability.
                          </li>
                          <li>
                            <strong>Production & MRP:</strong> MPS, material
                            requirement planning and capacity checks.
                          </li>
                          <li>
                            <strong>Warehouse:</strong> multi-location stock,
                            bin management and barcode scanning.
                          </li>
                        </ul>
                      </div>
                      <div className="col-md-6">
                        <ul className="list-unstyled">
                          <li>
                            <strong>Distribution & logistics:</strong> routing,
                            carrier management and freight costing.
                          </li>
                          <li>
                            <strong>Order fulfillment:</strong> pick/pack/ship,
                            returns & reverse logistics.
                          </li>
                          <li>
                            <strong>Inventory optimization:</strong> reorder
                            rules, ABC/XYZ and safety stock automation.
                          </li>
                          <li>
                            <strong>Reporting & KPIs:</strong> OTIF, lead-time,
                            stock turns and cost-to-serve.
                          </li>
                        </ul>
                      </div>
                    </div>
                  </div>
                </div>
              </div>

              {/* CTA and trusted badges */}
              <div className="col-lg-4">
                <div className="cta-strip text-center p-4 rounded">
                  <h5 className="mb-2">Optimize your supply chain</h5>
                  <p className="mb-3 small text-muted">
                    Book a demo and see how our platform reduces inventory costs
                    and improves delivery performance.
                  </p>
                  {/* <Button
                    variant="light"
                    size="sm"
                    as={Link}
                    to="#demo"
                    className="me-2"
                    onClick={this.handleTryNow}
                  >
                    <i className="fa-solid fa-calendar-check me-2" /> Book a
                    demo
                  </Button> */}
                  <Button
                    variant="primary"
                    size="sm"
                    as={Link}
                    to="/Checkout"
                    onClick={() =>
                      this.context.HandleTryNowButtonClick(
                        this.context.ProductType.SupplyChain
                      )
                    }
                  >
                    <i className="fa-regular fa-clock me-2" /> Start free trial
                  </Button>
                </div>

                <div className="card mt-3 border-0">
                  <div className="card-body small text-muted">
                    <strong>Trusted by:</strong>
                    <div className="mt-2 d-flex gap-2 flex-wrap">
                      <span className="badge bg-light text-dark">
                        Manufacturing
                      </span>
                      <span className="badge bg-light text-dark">Retail</span>
                      <span className="badge bg-light text-dark">F&B</span>
                    </div>
                  </div>
                </div>
              </div>
            </div>

            {/* Footer CTA */}
            <div className="row mt-5">
              <div className="col-12 text-center">
                <p className="text-muted small mb-2">
                  30-minute demo, no obligation — see Supply Chain in action.
                </p>
                {/* <Button
                  variant="outline-primary"
                  size="lg"
                  className="me-2"
                  onClick={this.handleTryNow}
                >
                  Book a demo +91-98805 82728
                </Button>
                <Button variant="primary" size="lg" as={Link} to="#contact">
                  Contact sales
                </Button> */}
                <DemoButton></DemoButton>
              </div>
            </div>
          </div>
        </section>

        {/* Supply Chain Modules Section */}
        <section className="container my-5">
          <h5 className="display-6 text-dark mb-4 border-start border-5 border-primary ps-3 py-5">
            Explore Supply Chain Modules That Keep Your Business Flowing
          </h5>

          <Row className="g-3">
            {moduleList.map((Module, index) => (
              <Col md={6} lg={6} key={index}>
                <div className="bg-light p-3 rounded shadow-sm h-100 hover-shadow">
                  {Module ? <Module /> : <div className="p-3">Module</div>}
                </div>
              </Col>
            ))}
          </Row>
        </section>
      </>
    );
  }
}

export default SupplyChain;
